import * as Api from '@/api';
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import FileSaver from 'file-saver';
import { _prepareErrors } from '@/utils/_function.js';
import { required } from 'vuelidate/lib/validators';
import {
  endDateIsBefore } from '@/utils/input_utils';
import moment from 'moment';

export default {
  name: 'Statistics',
  data() {
    return {
      ru: ru,
      logsParamForm: {},
      filerList: [],
      // proprietorOptions: this.proprietorSelectOptions,
      proprietorOptions: [],
      proprietorsListParam: [],
      isSelectedAllFiler: false,
      isSelectedAllProprietor: false
    };
  },
  validations() {
    return {
      logsParamForm: {
        startedAt: {
          required,
          isBefore: endDateIsBefore('endedAt')
        },
        endedAt: {
          required
        },
        proprietorIds: {
          required
        },
        filerIds: {
          required
        }
      }
    };
  },
  components: {
    Datepicker
  },
  watch: {
    'logsParamForm.proprietorIds': async function(data) {
      let param = null;
      let filerList = [];
      this.isSelectedAllProprietor = data.includes('all');

      if (this.isSelectedAllProprietor) {
        param = {
          queryString: {
            data: {
              proprietor_ids: []
            }
          }
        };
      } else {
        this.proprietorsListParam = data;
        param = {
          queryString: {
            data: {
              proprietor_ids: data
            }
          }
        };
      }

      await Api.getFilerList(param)
        .then((data) => {
          if (data.data && data.data.length > 0) {
            data.data.map((item) => {
              filerList.push({
                name: item.attributes.name,
                id: item.id
              });
            });
          }
        })
        .catch(() => {});

      if (this.isSelectedAllProprietor && data.length > 1) {
        this.logsParamForm.proprietorIds = ['all'];
      }

      if (!data.length) {
        this.logsParamForm.filerIds = [];
        filerList = [];
      }

      this.filerList = filerList.length ? [{ id: 'all', name: 'Выбрать всех' }, ...filerList] : filerList;
    },
    'logsParamForm.filerIds': function(data) {
      this.isSelectedAllFiler = data.includes('all');

      if (this.isSelectedAllFiler && data.length > 1) {
        this.logsParamForm.filerIds = ['all'];
      }
    },
    filerList: function(data) {
      if (data && data.length) {
        if (this.logsParamForm.filerIds && this.logsParamForm.filerIds.length) {
          this.logsParamForm.filerIds = this.logsParamForm.filerIds.filter(selectedFiler => (
            data.find(filer => (
              filer.id === selectedFiler
            ))
          ));
        }
      }
    }
  },
  async created() {
    const param = {
      queryString: {
        page: 1,
        per_page: 100,
        fields: ['name']
      }
    };
    let proprietorsList = [];

    await Api.getProprietorsListForSelect(param)
      .then((data) => {
        if (data && data.length > 0) {
          data.map((item) => {
            proprietorsList.push({
              name: item.attributes.name,
              id: item.id
            });
          });
        }
      })
      .catch(() => {});
    this.proprietorOptions = proprietorsList;

    this.proprietorOptions = [{ id: 'all', name: 'Выбрать всех' }, ...proprietorsList];
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: async(loading, search, vm) => {
      const param = {
        queryString: {
          page: 1,
          per_page: 100,
          fields: ['name'],
          search: { 'name': search.trim() }
        }
      };
      let proprietorsList = [];

      await Api.getProprietorsListForSelect(param)
        .then((data) => {
          if (data && data.length > 0) {
            data.map((item) => {
              proprietorsList.push({
                name: item.attributes.name,
                id: item.id
              });
            });
          }

          loading(false);
        })
        .catch(() => {});
      vm.proprietorOptions = proprietorsList;
    },
    onSearchFilers(search, loading) {
      loading(true);
      this.searchFiler(loading, search, this);
    },
    searchFiler: async function(loading, search, vm) {
      const param = {
        queryString: {
          fields: ['name'],
          search: { 'name': search.trim() },
          data: {
            proprietor_ids: this.proprietorsListParam || []
          },
          page: 1,
          per_page: 100
        }
      };

      let filerList = [];

      await Api.getFilerList(param)
        .then((data) => {
          if (data.data && data.data.length > 0) {
            data.data.map((item) => {
              filerList.push({
                name: item.attributes.name,
                id: item.id
              });
            });
          }

          loading(false);
        })
        .catch(() => {});
      vm.filerList = filerList;
    },
    customFormatter(date) {
      return moment(date).hours(23, 'hours').minutes(59, 'minutes').format();
    },
    download() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const param = {
        data: {
          ...this.logsParamForm,
          endedAt: this.customFormatter(this.logsParamForm.endedAt)
        }
      };

      if (this.logsParamForm.proprietorIds.includes('all')) {
        delete param.data.proprietorIds;
      }

      if (this.logsParamForm.filerIds.includes('all')) {
        delete param.data.filerIds;
      }

      Api.getStatisticsCSV(param)
        .then((response) => {
          if (response) {
            var blob = new Blob([response.csv], { type: 'text/plain;charset=utf-8', encoding: 'utf-8' });
            FileSaver.saveAs(blob, 'csv.csv');
          }
        })
        .catch((errors) => {
          if (errors) {
            _prepareErrors(errors).forEach((err) => {
              this.$toastr('error', err, 'Ошибка');
            });

            this.$toastr('error', 'Ошибка скачивания файла', 'Ошибка');
          }
        });
    }
  }
};
